import { useEffect } from "react";
import Header from "../../components/AdminPortal/Header/Header";
import EditQuizeComponent from "../../components/AdminPortal/Quizzes/EditQuize";
import { useParams } from "react-router-dom";
import { useGetSingleQuizeQuery } from "../../features/quize/quizeApi";

export default function EditQuize() {
  useEffect(() => {
    document.title = "Edit Quize - LWS Learning Portal";
  }, []);
  const { quizeId } = useParams();
  const { data: quize, isLoading, isError } = useGetSingleQuizeQuery(quizeId);
  let content = null;
  if (isLoading) content = <p>Loading....</p>;
  if (!isLoading && isError) content = <p>Error</p>;
  if (!isLoading && !isError && quize?.id)
    content = <EditQuizeComponent quize={quize} />;
  return (
    <>
      <Header />
      <section className="py-6 bg-primary ">
        <div className="mx-auto px-5 lg:px-0" style={{ maxWidth: "45%" }}>
          <h4 className="mb-8 text-xl font-bold text-center">Edit Quize</h4>
          {content}
        </div>
      </section>
    </>
  );
}
